import { handleResponseV2, makeGet, makePost } from '@/redux/api/helpers';
import {
    HouseBillingAccountStatus,
    HouseBillingStatus,
} from '@/redux/modules/billingManagement/houseBillingStatus/houseBillingStatus.types';

type GetHouseBillingStatusParams = {
    authToken: string;
    deployment: string;
    houseId: number;
};

type GetHouseBillingStatusResponse = {
    error: boolean;
    payload: HouseBillingStatus;
};

export const getHouseBillingStatus = ({ authToken, deployment, houseId }: GetHouseBillingStatusParams) =>
    new Promise<GetHouseBillingStatusResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: `admin/house/${houseId}/billing`,
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });

        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });

type PostHouseBillingAccountStatusParams = {
    accountStatus: HouseBillingAccountStatus;
    authToken: string;
    deployment: string;
    houseId: number;
};

type PostHouseBillingAccountStatusResponse = {
    error: boolean;
};

export const postHouseBillingAccountStatus = ({
    accountStatus,
    authToken,
    deployment,
    houseId,
}: PostHouseBillingAccountStatusParams) =>
    new Promise<PostHouseBillingAccountStatusResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: `admin/house/${houseId}/billing/account-status`,
            authToken,
            deployment,
            path: '<PAYMENT-SERVER-API>',
        });
        request.send({
            accountStatus,
        });
        request.end((err, response) =>
            handleResponseV2({
                err,
                reject,
                resolve,
                response,
            })
        );
    });
